/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Metadata_Remove_LabelInputs */

const en_event_group_metadata_remove_label = /** @type {(inputs: Event_Group_Metadata_Remove_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove Metadata`)
};

const fr_event_group_metadata_remove_label = /** @type {(inputs: Event_Group_Metadata_Remove_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les métadonnées`)
};

const de_event_group_metadata_remove_label = /** @type {(inputs: Event_Group_Metadata_Remove_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metadaten entfernen`)
};

const it_event_group_metadata_remove_label = /** @type {(inputs: Event_Group_Metadata_Remove_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi metadati`)
};

const ru_event_group_metadata_remove_label = /** @type {(inputs: Event_Group_Metadata_Remove_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить метаданные`)
};

const es_event_group_metadata_remove_label = /** @type {(inputs: Event_Group_Metadata_Remove_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar metadatos`)
};

const zh_cn2_event_group_metadata_remove_label = /** @type {(inputs: Event_Group_Metadata_Remove_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除元数据`)
};

const ja_event_group_metadata_remove_label = /** @type {(inputs: Event_Group_Metadata_Remove_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メタデータを削除する`)
};

const hi_event_group_metadata_remove_label = /** @type {(inputs: Event_Group_Metadata_Remove_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मेटाडेटा हटाएँ`)
};

const pt_pt2_event_group_metadata_remove_label = /** @type {(inputs: Event_Group_Metadata_Remove_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover metadados`)
};

/**
* | output |
* | --- |
* | "Remove Metadata" |
*
* @param {Event_Group_Metadata_Remove_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_metadata_remove_label = /** @type {((inputs?: Event_Group_Metadata_Remove_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Metadata_Remove_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_metadata_remove_label(inputs)
	if (locale === "de") return de_event_group_metadata_remove_label(inputs)
	if (locale === "it") return it_event_group_metadata_remove_label(inputs)
	if (locale === "ru") return ru_event_group_metadata_remove_label(inputs)
	if (locale === "es") return es_event_group_metadata_remove_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_metadata_remove_label(inputs)
	if (locale === "ja") return ja_event_group_metadata_remove_label(inputs)
	if (locale === "hi") return hi_event_group_metadata_remove_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_metadata_remove_label(inputs)
	return en_event_group_metadata_remove_label(inputs)
});